import { render } from "./CookieBannerComponent.vue?vue&type=template&id=e965b380&scoped=true"
import script from "./CookieBannerComponent.vue?vue&type=script&lang=js"
export * from "./CookieBannerComponent.vue?vue&type=script&lang=js"

import "./CookieBannerComponent.vue?vue&type=style&index=0&id=e965b380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e965b380"]])

export default __exports__